module.exports = __webpack_public_path__ + "static/media/wpbeginner.856bdefd.svg";